import { default as direct43CBHZZbbRMeta } from "/tmp/build/38bfee86/code/pages/[slug]/direct.vue?macro=true";
import { default as index2ndsjHwlUgMeta } from "/tmp/build/38bfee86/code/pages/[slug]/index.vue?macro=true";
import { default as processingScJhg0dRi4Meta } from "/tmp/build/38bfee86/code/pages/[slug]/processing.vue?macro=true";
import { default as summary7Sv6k30kURMeta } from "/tmp/build/38bfee86/code/pages/[slug]/summary.vue?macro=true";
export default [
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___en",
    path: direct43CBHZZbbRMeta?.path ?? "/en/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___pt",
    path: direct43CBHZZbbRMeta?.path ?? "/pt/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___ca",
    path: direct43CBHZZbbRMeta?.path ?? "/ca/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___es",
    path: direct43CBHZZbbRMeta?.path ?? "/es/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___fr",
    path: direct43CBHZZbbRMeta?.path ?? "/fr/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___it",
    path: direct43CBHZZbbRMeta?.path ?? "/it/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___nl",
    path: direct43CBHZZbbRMeta?.path ?? "/nl/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: direct43CBHZZbbRMeta?.name ?? "slug-direct___de",
    path: direct43CBHZZbbRMeta?.path ?? "/de/:slug()/direct",
    meta: direct43CBHZZbbRMeta || {},
    alias: direct43CBHZZbbRMeta?.alias || [],
    redirect: direct43CBHZZbbRMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___en",
    path: index2ndsjHwlUgMeta?.path ?? "/en/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___pt",
    path: index2ndsjHwlUgMeta?.path ?? "/pt/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___ca",
    path: index2ndsjHwlUgMeta?.path ?? "/ca/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___es",
    path: index2ndsjHwlUgMeta?.path ?? "/es/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___fr",
    path: index2ndsjHwlUgMeta?.path ?? "/fr/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___it",
    path: index2ndsjHwlUgMeta?.path ?? "/it/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___nl",
    path: index2ndsjHwlUgMeta?.path ?? "/nl/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index2ndsjHwlUgMeta?.name ?? "slug___de",
    path: index2ndsjHwlUgMeta?.path ?? "/de/:slug()",
    meta: index2ndsjHwlUgMeta || {},
    alias: index2ndsjHwlUgMeta?.alias || [],
    redirect: index2ndsjHwlUgMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___en",
    path: processingScJhg0dRi4Meta?.path ?? "/en/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___pt",
    path: processingScJhg0dRi4Meta?.path ?? "/pt/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___ca",
    path: processingScJhg0dRi4Meta?.path ?? "/ca/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___es",
    path: processingScJhg0dRi4Meta?.path ?? "/es/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___fr",
    path: processingScJhg0dRi4Meta?.path ?? "/fr/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___it",
    path: processingScJhg0dRi4Meta?.path ?? "/it/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___nl",
    path: processingScJhg0dRi4Meta?.path ?? "/nl/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingScJhg0dRi4Meta?.name ?? "slug-processing___de",
    path: processingScJhg0dRi4Meta?.path ?? "/de/:slug()/processing",
    meta: processingScJhg0dRi4Meta || {},
    alias: processingScJhg0dRi4Meta?.alias || [],
    redirect: processingScJhg0dRi4Meta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___en",
    path: summary7Sv6k30kURMeta?.path ?? "/en/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___pt",
    path: summary7Sv6k30kURMeta?.path ?? "/pt/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___ca",
    path: summary7Sv6k30kURMeta?.path ?? "/ca/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___es",
    path: summary7Sv6k30kURMeta?.path ?? "/es/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___fr",
    path: summary7Sv6k30kURMeta?.path ?? "/fr/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___it",
    path: summary7Sv6k30kURMeta?.path ?? "/it/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___nl",
    path: summary7Sv6k30kURMeta?.path ?? "/nl/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summary7Sv6k30kURMeta?.name ?? "slug-summary___de",
    path: summary7Sv6k30kURMeta?.path ?? "/de/:slug()/summary",
    meta: summary7Sv6k30kURMeta || {},
    alias: summary7Sv6k30kURMeta?.alias || [],
    redirect: summary7Sv6k30kURMeta?.redirect,
    component: () => import("/tmp/build/38bfee86/code/pages/[slug]/summary.vue").then(m => m.default || m)
  }
]